"use client";
import { useContext } from "react";
import { RecentLeaderContext } from "@/context/RecentLeaderBoardContext";
import "./recent.scss";
import React from ".";
import TeamSection from "@/components/TeamSection";
import MatchHistoryTable from "@/components/MatchHistoryTable";

const RecentTable = (props) => {
  const {
    home,
    away,
    homeMatches: homeMatchesData,
    awayMatches: awayMatchesData,
    homeHalftimeChecked,
    awayHalftimeChecked,
    homeTotal,
    awayTotal,
  } = useContext(RecentLeaderContext);

  const {
    matches: homeMatches,
    winLossRate: homeWinLossRate,
    halfTimeWinLossRate: homeHalfTimeWinLossRate,
    handicapRate: homeHandicapRate,
    overUnderRate: homeOverUnderRate,
  } = homeMatchesData;
  const {
    matches: awayMatches,
    winLossRate: awayWinLossRate,
    halfTimeWinLossRate: awayHalfTimeWinLossRate,
    handicapRate: awayHandicapRate,
    overUnderRate: awayOverUnderRate,
  } = awayMatchesData;

  return (
    <>
      {/*home*/}
      <div className="my-2 p-4 rounded-lg bg-[var(--theme-foreground)] border border-[var(--theme-border)]">
        {/*home*/}
        <TeamSection
          isHome={true}
          team={home}
          total={homeTotal}
          winLossRate={
            homeHalftimeChecked ? homeHalfTimeWinLossRate : homeWinLossRate
          }
          totalRate={homeMatches.length}
          handicapRate={homeHandicapRate}
          overUnderRate={homeOverUnderRate}
        />
        <MatchHistoryTable
          isHome={true}
          matches={homeMatches}
          isHalftimeChecked={homeHalftimeChecked}
        />
      </div>

      {/*away*/}
      <div className="my-2 p-4 rounded-lg bg-[var(--theme-foreground)] border border-[var(--theme-border)]">
        <TeamSection
          isHome={false}
          team={away}
          total={awayTotal}
          totalRate={awayMatches.length}
          winLossRate={
            awayHalftimeChecked ? awayHalfTimeWinLossRate : awayWinLossRate
          }
          handicapRate={awayHandicapRate}
          overUnderRate={awayOverUnderRate}
        />
        <MatchHistoryTable
          isHome={false}
          matches={awayMatches}
          isHalftimeChecked={awayHalftimeChecked}
        />
      </div>
    </>
  );
};

export default RecentTable;
